{
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("body header-component.header");
    let lastScrollTop = 0;

    function toggleHeaderClass() {
      if (!header) return;

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop <= 50) {
        header.classList.remove("headertop");
        header.classList.remove("headersticky");
      } else {
        header.classList.add("headertop");

        if (scrollTop < lastScrollTop) {
          // scroll up
          header.classList.add("headersticky");
          header.classList.remove("headertop");
        } else {
          // scroll down
          header.classList.remove("headersticky");
        }
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener("scroll", toggleHeaderClass);
    window.addEventListener("load", toggleHeaderClass);
  });
}

{
  class FiltersToggle {
  constructor() {
    this.trigger = document.querySelector(
      '.product-grid-container .facets-controls-wrapper > .facets--filters-title'
    );

    this.target = document.querySelector(
      '.product-grid-container .collection-wrapper > div.facets-block-wrapper--vertical.facets-block-wrapper'
    );

    this.init();
  }

  init() {
    if (!this.trigger || !this.target) return;

    this.trigger.addEventListener('click', () => {
      this.target.classList.toggle('isFilterActive');
    });
  }
}

// Init
document.addEventListener('DOMContentLoaded', () => {
  new FiltersToggle();
});
}